// extracted by mini-css-extract-plugin
export default {"defaultSize":"ZTzZAghgAobGF3kqLBiQ","navWrapper":"nefNRIb69auv7r_iClhe"};